export default "__VITE_ASSET__68fe7ebf__"